module.exports = __webpack_public_path__ + "img/bottom.8db685ea.png";